import { connect } from 'react-redux'

import SupportPage from '../SupportPage'

import { setError } from '../../ducks/error'

function mapStateToProps(state) {
  return {
    language: state.account.get('currentLanguage'),
    hasError: state.error.get('errorMessage') !== null
  }
}

export default connect(mapStateToProps, { setError })(SupportPage)



// WEBPACK FOOTER //
// ./src/components/smart/SupportPageContainer.js